import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('quote_rate_member_rates',
  '/plans/quote_rate_member_rates',
  'quote_rate_member_rates')
const reducer = generator.generate()

export default reducer

